import { useEffect, useRef } from 'react';
import { mountSandboxedHtml } from '../lib/sandboxedAd';

/**
 * Renders article HTML and executes any embedded <script> tags (ads/widgets)
 * inside sandboxed iframes - see /app/frontend/src/lib/sandboxedAd.js for the
 * security rationale (no top-level redirect possible) and grouping logic.
 * All real text/media content stays in the main document, fully visible to
 * users, crawlers, and social scrapers.
 */
const HtmlContent = ({ html, className = '' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const container = containerRef.current;
    const cleanupAds = mountSandboxedHtml(container, html);

    return () => {
      cleanupAds();
      container.querySelectorAll('video, audio').forEach((el) => {
        try { el.pause(); } catch (e) {}
      });
    };
  }, [html]);

  if (!html) return null;

  return (
    <div
      ref={containerRef}
      className={className}
      data-testid="article-body"
    />
  );
};

export default HtmlContent;
